module.exports = __webpack_public_path__ + "img/thumb-oamm2a@2x.37858bcf.png";